<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/common/css/base.css"; //页面样式
export default {
  name: "App",
  created() {
    window.$route = this.$route;
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  color: #2c3e50;
}
.all {
  width: 750px;
  overflow-x: hidden;
  padding: 0;
  z-index: -99;
}
.redBtn {
  width: 640px;
  height: 80px;
  margin: 10px auto;
  border-radius: 50px;
  color: #ffffff;
  font-size: 34px;
  line-height: 80px;
  background-color: #ff4d4d;
  border: 1px #ff4d4d solid;
}
.whiteBtn {
  width: 640px;
  height: 80px;
  margin: 10px auto;
  border-radius: 50px;
  color: #ff4d4d;
  font-size: 34px;
  line-height: 80px;
  background: #ffffff;
  border: 1px #ff4d4d solid;
}
</style>



// WEBPACK FOOTER //
// src/App.vue